import filter from 'lodash/filter'
import defaultTo from 'lodash/defaultTo'
import assign from 'lodash/assign'

export default ApiService

/** @ngInject */
function ApiService($q, User, Features, ContractStatus, ErrorCatcher) {
    const CONTRACT_TO_HIDE = [ContractStatus.duplicat]
    const UNSELECTABLE_CONTRACT_STATUS = [ContractStatus.resilie, ContractStatus.retracte, ContractStatus.annule]

    const displayContract = (c) => CONTRACT_TO_HIDE.indexOf(c.status) === -1
    const selectableContract = (c) => UNSELECTABLE_CONTRACT_STATUS.indexOf(c.status) === -1

    const promises = {
        userInfo: null,
        features: null,
    }

    const resetPromise = (key) => {
        promises[key] = null
    }

    const fetchUserInfo = function () {
        if (!promises.userInfo) {
            promises.userInfo = User.getInfo().$promise
            .then((response) => {
                return assign({}, response, {
                    contracts: response.contracts,
                    contractSelected: defaultTo(filter(response.contracts, selectableContract)[0], response.contracts && response.contracts[0]),
                })
            })
            .catch((error) => {
                ErrorCatcher.catchError(error)
                return $q.reject(error)
            })
        }
        return promises.userInfo
    }

    const fetchFeatures = function () {
        if (!promises.features) {
            promises.features = Features.get().$promise
        }
        return promises.features
    }

    return {
        fetchFeatures,
        fetchUserInfo,
        resetPromise,
    }
}



// WEBPACK FOOTER //
// ./src/services/api/api.js